import { z } from "zod";

export type DeclineMode = "breast-mri" | "genetic-testing" | "lung-ct";

export type WeekDay = "monday" | "tuesday" | "wednesday" | "thursday" | "friday";

const dayAvailability = z.object({
  enabled: z.boolean().default(false),
  am: z.boolean().default(false),
  pm: z.boolean().default(false),
});

export const preferredAppointmentAvailability = z.object({
  anytime: z.boolean().default(false),
  monday: dayAvailability,
  tuesday: dayAvailability,
  wednesday: dayAvailability,
  thursday: dayAvailability,
  friday: dayAvailability,
});

export const takeActionSchema = z.object({
  screenings: z.object({
    geneticTesting: z.boolean().optional(),
    breastMRI: z.boolean().optional(),
    lungCT: z.boolean().optional(),
  }),
  preferredAppointmentAvailability: preferredAppointmentAvailability,
});

export type TakeActionType = z.infer<typeof takeActionSchema>;
export type PreferredAppointmentAvailabilityType = z.infer<
  typeof preferredAppointmentAvailability
>;
export type DayAvailabilityType = z.infer<typeof dayAvailability>;
